import React, { useState } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { EditorialMarqueeSection } from "../components/MarqueeSection";
import { AboutTherapist } from "../components/AboutTherapist";
import { ServicesGrid } from "../components/ServicesGrid";
import { ManifestoChapters } from "../components/ManifestoChapters";
import { Packages } from "../components/Packages";
import { PurchaseModal } from "../components/PurchaseModal";
import { CouplesTherapy } from "../components/CouplesTherapy";
import { ProgramsSection } from "../components/ProgramsSection";
import { RegisterModal } from "../components/RegisterModal";
import { Testimonials } from "../components/Testimonials";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";
import { BookingModal } from "../components/BookingModal";
import { InstagramFeed } from "../components/InstagramFeed";
import { StudioGallery } from "../components/StudioGallery";

export default function Home() {
  const [booking, setBooking] = useState(false);
  const [regProgram, setRegProgram] = useState(null);
  const [buyPkg, setBuyPkg] = useState(null);
  const open = () => setBooking(true);
  return (
    <div className="relative">
      <div className="grain" />
      <Navbar onBook={open} />
      <Hero onBook={open} />
      <EditorialMarqueeSection />
      <AboutTherapist onBook={open} />
      <StudioGallery />
      <ServicesGrid onBook={open} />
      <CouplesTherapy onBook={open} />
      <ManifestoChapters />
      <Packages onBook={open} onBuy={setBuyPkg} />
      <ProgramsSection kind="offer" id="offers" accent="blush" overline="Current offers"
        title="Current offers for clients" subtitle="Limited-time ways to begin your journey for less."
        onRegister={setRegProgram} />
      <ProgramsSection kind="workshop" id="workshops" overline="Workshops & programmes"
        title="Workshops, classes & programmes" subtitle="For students, interns and anyone keen to learn & grow."
        onRegister={setRegProgram} />
      <Testimonials />
      <InstagramFeed />
      <ContactSection />
      <Footer onBook={open} />
      <BookingModal open={booking} onClose={() => setBooking(false)} />
      <RegisterModal program={regProgram} onClose={() => setRegProgram(null)} />
      <PurchaseModal pkg={buyPkg} onClose={() => setBuyPkg(null)} />
    </div>
  );
}
